import http from "./httpService";

const apiEndpoint = "/client/users";

function userUrl(id) {
  return `${apiEndpoint}/${id}`;
}

export function getUsers(params = {}) {
  return http.get(apiEndpoint, { params });
}

export function getCurrentUser() {
  return http.get(`/client/`);
}

export function getUser(userId) {
  return http.get(userUrl(userId));
}

export function saveUser(user) {
  if (user.id) {
    const body = { ...user };
    delete body.id;
    return http.put(userUrl(user.id), body);
  }

  console.log (http.post(apiEndpoint, user));
  return http.post(apiEndpoint, user);
}

export function deleteUser(userId) {
  return http.delete(userUrl(userId));
}
